import { Component, Input } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { QuestionConfig } from 'src/app/shared/interfaces/process-config.interface';

@Component({
  selector: 'app-calibration-qualitative-evaluation',
  templateUrl: './qualitative-evaluation.component.html',
  styleUrls: ['./qualitative-evaluation.component.scss']
})
export class CalibrationUserQualitativeEvaluation extends BaseClass {

  @Input() questions: Array<QuestionConfig>;
  @Input() possibleValues?: Array<string>;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService
  ) {
    super(_toastController, _translationService);
  }

}
